import { render, staticRenderFns } from "./KerkInfo.vue?vue&type=template&id=6be6e4e7&scoped=true"
import script from "./KerkInfo.vue?vue&type=script&lang=js"
export * from "./KerkInfo.vue?vue&type=script&lang=js"
import style1 from "./KerkInfo.vue?vue&type=style&index=1&id=6be6e4e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be6e4e7",
  null
  
)

export default component.exports